var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    iconName: "IconTrashBinFill",
    className: "css-6xix1i",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 6v2h11a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2.68L38.78 37c-.2 3.17-.29 4.76-.97 5.96a6 6 0 0 1-2.6 2.45c-1.24.6-2.83.6-6 .6H18.8c-3.18 0-4.77 0-6.01-.6a6 6 0 0 1-2.6-2.45c-.68-1.2-.78-2.79-.97-5.96L7.68 12H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h11V6a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5ZM21 5a1 1 0 0 0-1 1v2h8V6a1 1 0 0 0-1-1h-6Zm-2.19 13.5a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h2.13a1 1 0 0 0 1-1v-15a1 1 0 0 0-1-1H18.8Zm7.25 1v15a1 1 0 0 0 1 1h2.13a1 1 0 0 0 1-1v-15a1 1 0 0 0-1-1h-2.13a1 1 0 0 0-1 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.fa4e50ea72dfd06fa28872c429441cb0.svg";
export { ForwardRef as ReactComponent };